/**
 * Created by Ning Jiang on 2/3/2020.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {AnimatedParticle, Emitter} from "pixi-particles";
import {DeadwoodGameConfig} from "../DeadwoodGameConfig";

export class FireParticles extends BaseView {

    public static START:string = "fireParticlesEvent_Start";
    public static STOP:string = "fireParticlesEvent_Stop";

    private _backgroundConfig0:any = { // fast particles
        "alpha" : {
            "start" : 1,
            "end" : 0.22
        },
        "scale" : {
            "start" : 0.6,
            "end" : 0.8,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 400,
            "end" : 200,
            "minimumSpeedMultiplier" : 2
        },
        "acceleration" : {
            "x" : 0,
            "y" : 0
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : -15,
            "max" : 15
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 15
        },
        "lifetime" : {
            "min" : 6,
            "max" : 8
        },
        "blendMode" : "add",
        "frequency" : 0.15,
        "emitterLifetime" : -1,
        "maxParticles" : 200,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -1,
            "y" : 0,
            "w" : 1,
            "h" : 720
        }
    };

    private _backgroundConfig1:any = { //middle
        "alpha" : {
            "start" : 1,
            "end" : 0.22
        },
        "scale" : {
            "start" : 0.4,
            "end" : 0.7,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 200,
            "end" : 100,
            "minimumSpeedMultiplier" : 2
        },
        "acceleration" : {
            "x" : 0,
            "y" : 0
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : -15,
            "max" : 15
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 10
        },
        "lifetime" : {
            "min" : 6,
            "max" : 10
        },
        "blendMode" : "add",
        "frequency" : 0.12,
        "emitterLifetime" : -1,
        "maxParticles" : 200,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -1,
            "y" : 0,
            "w" : 1,
            "h" : 720
        }
    };

    private _backgroundConfig2:any = { //slow
        "alpha" : {
            "start" : 1,
            "end" : 0.22
        },
        "scale" : {
            "start" : 0.25,
            "end" : 0.5,
            "minimumScaleMultiplier" : 0.5
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 100,
            "end" : 50,
            "minimumSpeedMultiplier" : 2
        },
        "acceleration" : {
            "x" : 0,
            "y" : 0
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : -30,
            "max" : 30
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 0,
            "max" : 5
        },
        "lifetime" : {
            "min" : 10,
            "max" : 14
        },
        "blendMode" : "add",
        "frequency" : 0.1,
        "emitterLifetime" : -1,
        "maxParticles" : 200,
        "pos" : {
            "x" : 0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : -1,
            "y" : 0,
            "w" : 1,
            "h" : 720
        }
    };

    private _backgroundEmitters:Emitter[];
    private _isPlaying:boolean = false;

    private _backgroundLayer:ScalableLayer;

    private _currentOreintation:string;

    constructor() {
        super();
    }

    protected initAnimations():void {
        this._backgroundEmitters = [];
        this._backgroundLayer = StageManager.getLayer(DeadwoodGameConfig.instance.LAYERS.BACKGROUND.name);
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, FireParticles.START, (event:GameEvent) => this.onPlay(true));
        EventHandler.addEventListener(this, FireParticles.STOP, (event:GameEvent) => this.onPlay(false));
    }

    private onPlay(play:boolean):void {
        if(play === this._isPlaying) {
            return;
        }

        this._isPlaying = play;
        if(play && this._isResizeDirty) {
            this.onResize(this._resizeData);
        }
        this._backgroundEmitters.forEach((emitter:Emitter) => {
            emitter.emit = play;
        });
    }

    protected onResize(resizeData:IResizeData):void {
        if(this._currentOreintation === this._resizeData.orientation) {
            return;
        }

        if(!this._isPlaying) {
            this._isResizeDirty = true;
            return;
        }

        this._isResizeDirty = false;
        this._currentOreintation = resizeData.orientation;

        while(this._backgroundEmitters.length > 0) {
            ParticlesManager.removeEmitter(this._backgroundEmitters.pop()!);
        }
        this.addEmitters();
    }

    private addEmitters():void {
        this._backgroundEmitters.push(this.createEmitter(this._backgroundLayer, [
            GameResources.getTextures("fireParticle1")[0],
            GameResources.getTextures("fireParticle2")[0]
        ], this._backgroundConfig0, false));
        this._backgroundEmitters.push(this.createEmitter(this._backgroundLayer, [
            GameResources.getTextures("fireParticle2")[0],
            GameResources.getTextures("fireParticle3")[0]
        ], this._backgroundConfig1, false));
        this._backgroundEmitters.push(this.createEmitter(this._backgroundLayer, [
            GameResources.getTextures("fireParticle2")[0],
            GameResources.getTextures("fireParticle3")[0]
        ], this._backgroundConfig2, false));
    }

    private createEmitter(container:PIXI.Container, particleImages:any, config:any, isAnimated:boolean):Emitter {
        this.updateEmitterRect(config);
        const emitter:Emitter = new Emitter(container, particleImages, config);
        if(isAnimated) {
            emitter.particleConstructor = AnimatedParticle;
        }

        ParticlesManager.addEmitter(emitter);
        return emitter;
    }

    private updateEmitterRect(config:{ spawnRect:{ x:number, y:number, w:number, h:number } }):void {
        config.spawnRect.x = NolimitApplication.screenBounds.left;
        config.spawnRect.y = NolimitApplication.screenBounds.top;
        config.spawnRect.h = NolimitApplication.screenBounds.height;
    }
}